import { render } from "./EmpresaList.vue?vue&type=template&id=cdd7a4c2&scoped=true"
import script from "./EmpresaList.vue?vue&type=script&lang=js"
export * from "./EmpresaList.vue?vue&type=script&lang=js"

import "./EmpresaList.vue?vue&type=style&index=0&id=cdd7a4c2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd7a4c2"]])

export default __exports__